import React, { useEffect, useState } from 'react';
import styles from './PaymentPanelGroup.module.scss';
import icon1 from '@/assets/images/组 17@2x.png';
import { useTranslation } from "react-i18next";


interface PaymentPanelGroupProps {
  visible: boolean;
  onClose: () => void;
  total: string;
  selectedImages: string[];
  onCheckout: () => void;
}

const PaymentPanelGroup: React.FC<PaymentPanelGroupProps> = ({ visible, onClose, total, selectedImages, onCheckout }) => {
  const { t, i18n } = useTranslation();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 600);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  if (!visible || isMobile) return null;
  
  return (
    <div className={styles['panel-root']}>
      <div className={styles['panel-header']}>
        <span> 
            {t('Cart.PaymentBreakdown')}  
        </span>
        <span className={styles['panel-close']} onClick={onClose}>▲</span>
      </div>
      <div className={styles['panel-content']}>
        {selectedImages.length > 0 ? (
          <div className={styles['panel-images']}>
            {selectedImages.map((img, idx) => (
              <img key={idx} src={img} alt="product" className={styles['panel-img']} />
            ))}

          </div> 
        ) : (
          <div className={styles['panel-empty-img']}>
            <img src={icon1} alt="" />
          </div>
        )}
        <div className={styles['panel-total-row']}>
          <span> {t('Cart.GrandTotal')}: </span>
          <span className={styles['panel-total']}>${total}</span>
        </div>
        <button 
          className={styles['panel-checkout-btn']}
          onClick={onCheckout}
        >
          {t('Cart.Checkout')}
        </button>
      </div>
    </div>
  );
};

export default PaymentPanelGroup; 